<div [ngClass]="getBodyClass()">
    <div class="container-fluid body-width">
        <!-- @if((userRoleSwitch == 'Teacher' || userRoleSwitch == 'Group' || userRoleSwitch == ' GroupCoordinator' &&
        isAuthenticated) && showBanner) {
        <app-swich-back-to-python></app-swich-back-to-python>
        } -->
        <router-outlet *ngIf="permissionService.isPermissionsLoaded()"></router-outlet>
        <ngx-ui-loader></ngx-ui-loader>
        <app-status-popup></app-status-popup>
    </div>
</div>